import EditAutomationInput from './EditAutomationInput';

export default EditAutomationInput;
